(() => {
  const offer = document.getElementById('mobile-offer');
  const update = () => {
    const visible = window.innerWidth < 750 && window.scrollY > 3000;
    offer.classList.toggle('is-visible', visible);
    offer.setAttribute('aria-hidden', String(!visible));
    document.body.classList.toggle('has-mobile-offer', visible);
  };
  window.addEventListener('scroll', update, { passive: true });
  window.addEventListener('resize', update);
  update();
})();
